module.exports = __webpack_public_path__ + "img/Real-Deal-Inactive.5811fda4.svg";